module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dkZjr"))).then(() => parcelRequire('dJXJK'));